import { NgModule } from '@angular/core';
import { CheckoutStoreModule } from './store';

@NgModule({
  imports: [CheckoutStoreModule],
})
export class CheckoutDataAccessModule {}
